export default __webpack_public_path__ + "static/media/21.726407d5.jpg";